<template>

    <th v-if="sortable" class="sortable" @click="$emit('toggle', field)">
        <div class="label">
            <span><slot></slot></span>
            <i v-if="$route.query.sort_key === field && $route.query.sort_dir === 'desc'" class="fas fa-caret-down"></i>
            <i v-if="$route.query.sort_key === field && $route.query.sort_dir === 'asc'" class="fas fa-caret-up"></i>
        </div>
    </th>

    <th v-else><slot></slot></th>

</template>

<style scoped lang="scss">

    th {
        @include font-semibold(11px);
        background: $color-bg;
        border: none;
        line-height: normal;
        padding: 10px 15px;
        transition: background-color .3s;
        vertical-align: middle;
        white-space: nowrap;
        &.sortable {
            background: $color-bg;
            cursor: pointer;
            user-select: none;
            &:hover {
                .label {
                    color: $color-primary;
                }
            }
            .label {
                background: transparent;
                color: $color-text;
                transition: color .3s;
            }
            i {
                color: inherit;
                margin-left: 5px;
            }
        }
    }

</style>

<script>

export default {

    props: {
        sortable: {
            type: Boolean,
            default: false,
        },
        field: {
            type: String,
        },
    },

}

</script>